let capitalize = (string) => {
  if (string == "client-case-study") string = 'case-study';
  console.log(string)
  let capital = string.toLowerCase()
    .split('-')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
  let no_dash = capital.replace('-', ' ')
  return no_dash
}

let datalist = (element) => {
  let list = document.querySelectorAll(element)
  let data = []

  list.forEach((item) => {
    data.push(item.getAttribute('data-id'))
  })

  return data
}

(function ($) {
  var section = $('.customer-landing');
  if (section.length > 0) {
    var post_per_page = 15,
      displayedPages,
      items = $('.resource-grid .col-three'),
      $pagination = $('.resource-grid .pagination');

    function filter(filter_items_arr) {
      var search_term = filter_items_arr[0].toLowerCase(),
        industry_term = filter_items_arr[1].toLowerCase(),
        product_term = filter_items_arr[2].toLowerCase(),
        team_term = filter_items_arr[3].toLowerCase();


        var queryParams = new URLSearchParams(window.location.search);
        if(team_term === "all_team"   && industry_term === "all_industry" && product_term === "all_product"){
          history.replaceState(null, null, "/customer-stories/");
        } else{
          if(product_term !== "all_product"){
            queryParams.set("product", product_term);
          } else{
            queryParams.delete("product");
          } 
  
          if(team_term !== "all_team"){
            queryParams.set("team", team_term);
          }else{
            queryParams.delete("team");
          }
          
          if(industry_term !== "all_industry" ){
            queryParams.set("industry", industry_term);
          }else{
            queryParams.delete("industry");
          }
          history.replaceState(null, null, "/customer-stories/?"+queryParams.toString());
        }
          
      
      $('.resource-grid .col-three').addClass('hide').removeClass('show filtered');
      $('.resource-grid .col-three[data-search*="' + search_term + '"][data-industry*="' + industry_term + '"][data-product*="' + product_term + '"][data-team*="' + team_term + '"]').removeClass('hide filter-hide').addClass('show filtered');
      var numProductCards = $('.resource-grid .col-three.filtered').length;
      if (numProductCards < post_per_page) {
        $pagination.pagination('destroy');
      } else {
        pagination();
      }
      var itemLength = items.length;
      var hiddenitemLength = $('.resource-grid .col-three.hide').length;
      if (hiddenitemLength >= itemLength) {
        $('.resource-grid .no-result').show();
      } else {
        $('.resource-grid .no-result').hide();
      }
      if (search_term === "all_search" && industry_term === "all_industry" && product_term === "all_product" && team_term === "all_team") {
        $(".resource-grid .clear-btn").hide();
      } else {
        $(".resource-grid .clear-btn").show();
      }
    }

    $(window).on("load resize", function () {
      var win_Width = $(this).width();
      if (win_Width > 580) {
        displayedPages = 4;
      } else {
        displayedPages = 1;
      }
      pagination();
    });
    $(window).on("load", function () {
      var filter_items = ["all_search", "all_industry", "all_product", "all_team"];
      var search = $('#search');
      if (search.val() !== "") {
        filter_items[0] = search.val();
      }

      //Customer-story parameter exists
      let params = new URL(document.location).searchParams;
      if (params.size > 0) {
        let industry_name = params.get("industry")
        let product_name = params.get("product")
        let team_name = params.get("team")
        let industry_type = $('.filter-wrap .filter .selector-wrap.industry .option-wrap li')
        let pro_type = $('.filter-wrap .filter .selector-wrap.product .option-wrap li')
        let team_type = $('.filter-wrap .filter .selector-wrap.team .option-wrap li')

        let industry_found = datalist('.filter-wrap .filter .selector-wrap.industry .option-wrap li').findIndex((element) => element == industry_name)
        let pro_found = datalist('.filter-wrap .filter .selector-wrap.product .option-wrap li').findIndex((element) => element == product_name)
        let team_found = datalist('.filter-wrap .filter .selector-wrap.team .option-wrap li').findIndex((element) => element == team_name)

        if (industry_name && industry_found >=0 ) {
          filter_items[1] = industry_name
          industry_type.parent().parent().find('span').text(capitalize(industry_name))
        }

        if (product_name && pro_found >=0 ) {
          filter_items[2] = product_name
          pro_type.parent().parent().find('span').text(capitalize(product_name))
        }
        console.log(team_name, team_found)
        if (team_name && team_found >= 0) {
          filter_items[3] = team_name 
          team_type.parent().parent().find('span').text(capitalize(team_name))
        }
        $('html, body').animate({scrollTop: $(".filter-wrap .filter .selector-wrap").offset().top - 90,}, 700, 'linear');

      }
     

      // search term
      search.on('input', function (e) {
        var text = $(this).val();
        if (text === "") {
          text = "all_search"
        }
        filter_items[0] = text;
        $('.resource-grid .no-result h3').text("No Result Found For " + text);
        filter(filter_items);
      });

      //Filter By Industry
      $('.filter-wrap .filter .selector-wrap.industry .option-wrap li').on('click', function () {
        var data_text = $(this).attr("data-id");
        var text = $(this).text();
        $(this).parent().parent().find('span').text(text);
        filter_items[1] = data_text;
        filter(filter_items);
      });

      //Filter By Product
      $('.filter-wrap .filter .selector-wrap.product .option-wrap li').on('click', function () {
        var data_text = $(this).attr("data-id");
        var text = $(this).text();
        $(this).parent().parent().find('span').text(text);
        filter_items[2] = data_text;
        filter(filter_items);
      });

      //Filter By Team
      $('.filter-wrap .filter .selector-wrap.team .option-wrap li').on('click', function () {
        var data_text = $(this).attr("data-id");
        var text = $(this).text();
        $(this).parent().parent().find('span').text(text);
        filter_items[3] = data_text;
        filter(filter_items);
      });

      $(".resource-grid .clear-btn").on("click", function () {
        filter_items = ["all_search", "all_industry", "all_product", "all_team"];
        filter(filter_items);
        $(".filter-wrap .filter .selector-wrap").each(function () {
          var text = $(this).find('.option-wrap li').eq(0).text();
          $(this).find('.selector span').text(text);
          $('.filter-wrap .search-box input').val("");
        });
      })

      filter(filter_items);
    });

    $('.filter-wrap .filter .selector-wrap .option-wrap li').on('click', function () {
      $(this).parent().parent().parent().find('.selector-wrap').removeClass("active");
    });

    function filteredSwitchPage(pageNumber) {
      var showFrom = post_per_page * (pageNumber - 1);
      var showTo = showFrom + post_per_page;
      items.filter('.filtered').removeClass('filter').addClass("filter-hide");
      items.filter('.filtered').slice(showFrom, showTo).removeClass('filter-hide');
    }

    function smoothScrollTo($offset) {
      if ($offset.length) {
        console.log($offset.offset().top);
        $('html, body').animate({scrollTop: $offset.offset().top - 200}, 700, 'linear');
      }
    }

    function pagination() {
      var numProductCards = $('.resource-grid .col-three.filtered').length;
      if (numProductCards > post_per_page) {
        items.filter('.filtered').slice(post_per_page).addClass('filter-hide');
        $pagination.pagination({
          items: numProductCards,
          itemsOnPage: post_per_page,
          // prevText: "<span><</span>",
          // nextText: "<span> > </span>",
          displayedPages: displayedPages,
          ellipsePageSet: false,
          onPageClick: function (pageNumber, e) {
            e.preventDefault();
            e.stopPropagation();
            filteredSwitchPage(pageNumber);
            smoothScrollTo($(".filter-wrap .search-box input"));
          },
        });
      } else {
        $pagination.pagination('destroy');
      }
    }


  }


})(jQuery);